<template>
  <div class="app-select-root">
    <label v-if="label" class="app-select-label" :for="inputId">{{ label }}</label>
    <select
      :id="inputId"
      class="app-select"
      :class="selectClasses"
      :value="currentValue"
      :disabled="disabled"
      v-bind="$attrs"
      @input="onInput"
      @change="onChange"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="opt in normalizedOptions"
        :key="opt.value"
        :value="opt.value"
        :disabled="opt.disabled"
      >{{ opt.text }}</option>
    </select>
    <small v-if="errorMessage" class="app-select-error app-select-error--visible">{{ errorMessage }}</small>
  </div>
</template>

<script>
export default {
  name: 'AppSelect',
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number], default: undefined },
    value: { type: [String, Number], default: undefined },
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    inputId: { type: String, default: () => 'app-select-' + Math.random().toString(36).substr(2, 9) },
    placeholder: { type: String, default: 'Seleccionar...' },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: null },
    state: { type: Boolean, default: null },
    errorMessage: { type: String, default: '' }
  },
  emits: ['update:modelValue', 'input', 'change'],
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    normalizedOptions() {
      return this.options.map(opt => {
        if (typeof opt === 'object') return opt
        return { value: opt, text: opt }
      })
    },
    selectClasses() {
      return {
        'app-select--sm': this.size === 'sm',
        'app-select--lg': this.size === 'lg',
        'app-select--valid': this.state === true,
        'app-select--invalid': this.state === false || !!this.errorMessage
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value, event)
      this.$emit('update:modelValue', event.target.value)
    },
    onChange(event) { this.$emit('change', event) }
  }
}
</script>

<style scoped>
.app-select-root { width: 100%; }
.app-select-label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #939393;
}
.app-select {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  appearance: auto;
}
.app-select:focus { border-color: #80bdff; outline: 0; box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.15); }
.app-select:disabled { background: #e9ecef; opacity: 1; }
.app-select--sm  { padding: 0.25rem 0.5rem; font-size: 0.875rem; }
.app-select--lg  { padding: 0.5rem 1rem; font-size: 1.25rem; }
.app-select--valid  { border-color: #34C38F; }
.app-select--invalid { border-color: #F46A6A; }
.app-select--invalid:focus { box-shadow: 0 0 0 0.2rem rgba(244,106,106,0.2); }

.app-select-error { display: none; margin-top: 4px; font-size: 80%; color: #F46A6A; }
.app-select-error--visible { display: block; }
</style>
